<template>
	<div class="jobs-approval-footer">
		<div class="jobs-approval-footer__content">
			<div class="jobs-approval-footer__selected">
				<img src="../../assets/shifts/SelectedJobs.png" alt="selected-jobs" width="45" height="45"/>
				<div class="jobs-approval-footer__info">
					<p>{{ jobsForApproval.length }} Shifts selected</p>
					<p class="jobs-approval-footer__deselect" @click="clearSelectedJobs">Deselect all</p>
				</div>
			</div>
			<div class="jobs-approval-footer__button" @click="onApproveJobsClick">Approve all</div>
		</div>
	</div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
	name: 'Footer',
	computed: {
		...mapState(['jobsForApproval']),
	},
	methods: {
		...mapActions(['setJobsForApproval', 'approveJobs', 'startInitialLoader', 'endInitialLoader']),
		clearSelectedJobs() {
			this.setJobsForApproval([]);
		},
		async onApproveJobsClick() {
			this.startInitialLoader();
			try {
				await this.approveJobs();
			} catch (error) {
				this.$toaster.error(error?.body?.error?.message || 'Something went wrong.');
			}
			this.endInitialLoader();
		},
	},
};
</script>

<style lang="scss">
.jobs-approval-footer {
	display: flex;
	flex-direction: row;
	justify-content: center;
	background-color: #FFFFFF;
	box-shadow: 5px -5px 10px rgba(0, 0, 0, 0.25);
	width: 100%;
	height: 100px;
	margin-top: 50px;

	&__content {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		width: 1470px;
		height: 100%;
		padding: 0 15px;
	}

	&__selected {
		display: flex;
		flex-direction: row;
	}

	&__info {
		display: flex;
		flex-direction: column;
		margin-left: 10px;

		p {
			margin: 0;
		}
	}

	&__deselect {
		color: #00b3f5;
		font-weight: 400;
		cursor: pointer;
	}

	&__button {
		font-size: 18px;
		line-height: 40px;
		text-align: center;
		background: #6fdaa5;
		border-radius: 2px;
		width: 180px;
		height: 45px;
		color: #ffffff;
		cursor: pointer;
		&:hover {
			font-weight: 600;
		}
	}

	@media screen and (max-width: 1500px) {
		&__content {
			width: 990px;
		}

		&__button {
			width: 170px;
			height: 40px;
		}
	}

	@media screen and (max-width: 990px) {
		&__content {
			width: 750px;
		}

		&__button {
			width: 150px;
			height: 35px;
			line-height: 35px;
		}
	}
}
</style>
